import { type FC, type ReactElement, forwardRef } from 'react';
import { ToggleStyle } from './types/enums';
import IndividualToggle from './Individual/IndividualToggle';
import SwitchToggle from './Switch/Switch';
import TabToggle from './Tab/Tab';
import type { TogglePropsTypes, ToggleTheme } from './types/propsType';
import type { IndividualTogglePropTypes } from './types/IndividualTogglePropTypes';
import type { TabProps } from './types/tabProps';
import type { SwitchPropsTypes } from './types/SwitchProps';
import styles from './Toggle.module.scss';

const Toggle: FC<TogglePropsTypes> = forwardRef<HTMLSpanElement, TogglePropsTypes>(
  ({ toggleStyle, ...restProps }: TogglePropsTypes, ref): ReactElement => {
    const { INDIVIDUAL, TABS } = ToggleStyle;
    const renderComponent = () => {
      switch (toggleStyle) {
        case INDIVIDUAL:
          return <IndividualToggle {...(restProps as IndividualTogglePropTypes)} />;
        case TABS:
          return <TabToggle {...(restProps as TabProps)} />;
        default:
          return <SwitchToggle {...(restProps as SwitchPropsTypes)} />;
      }
    };

    return (
      <span className={styles['toggle-container']} ref={ref}>
        {renderComponent()}
      </span>
    );
  },
);
Toggle.displayName = 'Toggle';

export { ToggleStyle };
export default Toggle;
export type { ToggleTheme };
